export default function ConversionCTA() {
  return (
    <section className="py-20 md:py-28 relative overflow-hidden" style={{ backgroundColor: '#0167F8' }}>
      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)',
        backgroundSize: '32px 32px',
      }}></div>

      <div className="max-w-site mx-auto px-4 md:px-6 text-center relative z-10">
        <div className="animate-on-scroll">
          <h2 className="font-heading text-[36px] md:text-[52px] font-bold text-background-50 tracking-[-0.02em] leading-[1.12]">
            Let&apos;s solve your<br />IT needs.
          </h2>
          <p className="mt-4 text-base md:text-lg text-background-50/80 leading-relaxed max-w-[520px] mx-auto">
            Tell us what your business needs. We&apos;ll help you find the right technology solution.
          </p>

          <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="tel:+919940148039"
              className="whitespace-nowrap inline-flex items-center gap-2 rounded-xl font-label text-sm font-semibold transition-all duration-300 cursor-pointer group hover:shadow-xl hover:shadow-black/10 hover:-translate-y-0.5"
              style={{ backgroundColor: '#FFFFFF', color: '#00164A', padding: '14px 28px' }}
            >
              <i className="ri-phone-line"></i>
              +91 99401 48039
            </a>
            <a
              href="mailto:techbridge32@gmail.com"
              className="whitespace-nowrap inline-flex items-center gap-2 rounded-xl font-label text-sm font-semibold border transition-all duration-300 cursor-pointer group hover:bg-white/10 hover:-translate-y-0.5"
              style={{ borderColor: 'rgba(255,255,255,0.3)', color: '#FFFFFF', padding: '14px 28px' }}
            >
              <i className="ri-mail-line"></i>
              techbridge32@gmail.com
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}